import React, { ChangeEvent } from "react";

interface SearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const Search = React.forwardRef<HTMLInputElement, SearchProps>(
  ({ className, placeholder, onChange, value }, ref, ...props) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value);
    };

    return (
      <label className={`flex items-center ${className}`}>
        <input
          type="text"
          className="grow flex-1 px-4 py-2 h-10 w-[300px] text-sm rounded-l-lg border border-gray-300 focus:outline-none focus:ring-1 focus:ring-primary"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          {...props}
          ref={ref}
        />
        <div className="rounded-r-lg bg-primary h-10 w-10 text-white flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="w-6 h-6 opacity-70"
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </label>
    );
  }
);

export default Search;
